import { Display } from "../../../../Models/Display";

// Responsive GRID to Header
export const getHeaderGridLayout = (display: Display) => ({
  columns: display.xs
    ? "1fr 1fr"
    : display.sm || display.md
      ? "1fr 1fr 1fr"
      : "50% 1fr 1fr 1fr",
  areas: display.xs
    ? `
      "service service"
      "costShipment valueShipmentCost"
      "weightAndVolume weightAndVolume"
    `
    : display.sm || display.md
      ? `
        " service service service "
        " costShipment weightAndVolume valueShipmentCost "
      `
      : `
        " service costShipment weightAndVolume valueShipmentCost "
      `,
});

// Responsive GRID to Main
export const getMainGridLayout = (display: Display) => ({
  columns: display.xs || display.sm ? "1fr" : "50% 1fr",
  rows: "0fr 0fr 1fr auto ",
  areas:
    display.xs || display.sm
      ? `
      " header "
      " pickupAndDelivery "
      " generalInformation "
      " labelAndDocuments "
      " parcels "
      " customData "
    `
      : `
      " header header"  
      " pickupAndDelivery labelAndDocuments"
      " generalInformation labelAndDocuments"
      " parcels parcels"
      " customData customData"
    `,
});

// Responsive GRID to CardInformationCost
export const getCardInformationCostGridLayout = () => ({
  columns: "0.25fr 1fr",
  areas: `
    " carrier nameCarrierAndShipmentType "
  `,
});

// Responsive GRID to General Information
export const getGeneralInformationGridLayout = (display: Display) => ({
  columns: display.xs && display.sm ? "1fr" : "1fr 1fr",
  areas:
    display.xs && display.sm
      ? `
      " internalReference "
      " externalReference "
      " creationUser "
      " creationDate "
      " note "
      " content "
    `
      : `
        " internalReference externalReference "
        " creationUser creationDate "
        " note note "
        " content content "
      `,
});
